import { TournamentPlayersPage } from "@/pages/tournament/players/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/tournament/players")({
    component: TournamentPlayersPage,
});
